import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from 'src/assets/Configuration';
import { TrainingSummaryModel } from '../models/training/training-summary.model';
import { EventPublishingSettingsModel } from '../models/event-publishing-settings/event-publishing-settings.model';

@Injectable({
  providedIn: 'root'
})
export class TrainingPublicOverviewService {

  private httpClient: HttpClient;

  constructor(httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
  }

  getTrainings(accessToken: string): Observable<TrainingSummaryModel[]> {
    return this.httpClient.get<TrainingSummaryModel[]>(
      Configuration.getApiBaseUrl() + `/public-training-overview/${accessToken}`
    );
  }

  getSettings(accessToken: string): Observable<EventPublishingSettingsModel> {
    return this.httpClient.get<EventPublishingSettingsModel>(
      Configuration.getApiBaseUrl() + `/public-training-overview/${accessToken}/settings`
    );
  }

  getLogo(accessToken: string): Observable<string> {
    return this.httpClient.get(
      Configuration.getApiBaseUrl() + `/public-training-overview/${accessToken}/logo`,
      { responseType: 'text' }
    );
  }
}